module.exports = __webpack_public_path__ + "static/media/Mantova.d98d7e9b.png";